var _path, _circle, _circle2, _path2, _circle3, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 48 48",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.83 31.14c-2.33 1.83-3.83 4.67-3.83 7.86v3h-6c-1.66 0-3-1.34-3-3v-2c0-3.87 3.13-7 7-7h2c1.42 0 2.73.42 3.83 1.14z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 25.5,
    r: 4.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 25.5,
    r: 4.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m44 37v2c0 1.66-1.34 3-3 3h-6v-3c0-3.19-1.5-6.03-3.83-7.86 1.1-.72 2.41-1.14 3.83-1.14h2c3.87 0 7 3.13 7 7z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25.5,
    r: 5.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25 31h-2c-4.411 0-8 3.589-8 8v3c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-3c0-4.411-3.589-8-8-8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m38.5 16.684-2.413.858c-.685.243-1.4-.276-1.38-1.003l.07-2.56-1.562-2.03c-.443-.576-.17-1.417.527-1.623l2.457-.724 1.448-2.113c.411-.599 1.295-.599 1.706 0l1.448 2.113 2.457.724c.697.205.97 1.047.527 1.623l-1.562 2.03.07 2.56c.02.726-.696 1.246-1.38 1.003z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9.5 16.684-2.413.858c-.685.243-1.4-.276-1.38-1.003l.07-2.56-1.562-2.03c-.443-.576-.17-1.417.527-1.623l2.457-.724 1.448-2.113c.411-.599 1.295-.599 1.706 0l1.448 2.113 2.457.724c.697.205.97 1.047.527 1.623l-1.562 2.03.07 2.56c.02.726-.696 1.246-1.38 1.003z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m24 14.434-2.861 1.017c-.812.289-1.66-.328-1.636-1.189l.083-3.035-1.852-2.407c-.525-.683-.201-1.68.625-1.924l2.913-.859 1.717-2.505c.487-.711 1.536-.711 2.023 0l1.717 2.505 2.913.859c.826.244 1.15 1.241.625 1.924l-1.852 2.407.083 3.035c.024.861-.825 1.478-1.636 1.189l-2.861-1.017z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerReview);
export default __webpack_public_path__ + "static/media/customer-review.f197b8ba7385d548f6a9fd8a1f78ac5f.svg";
export { ForwardRef as ReactComponent };